export default __webpack_public_path__ + "static/media/Hayley 9781843626381.f76f5d80.jpg";